import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * distinctUntilChanged par comparaison structurelle (JSON.stringify).
 * Les payloads de filtres sont recréés à chaque émission : la comparaison par
 * référence de distinctUntilChanged() laisse passer tous les doublons, ce qui
 * relance inutilement des requêtes serveur coûteuses (catalogues notamment).
 */
export function distinctUntilChangedDeep<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr));
}
